<template>
  <el-dialog
      title="下单详情"
      :visible.sync="dialogVisible"
      width="640px"
      center
      @close="handleClose"
  >
    <div ref="captureArea" class="message-content-capture">
      <div class="capture-header">下单详情</div>
      <table class="message-content-table">
        <thead>
          <tr>
            <th>字段</th>
            <th>内容</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableRows" :key="index">
            <td class="label-cell">{{ item.label }}</td>
            <td class="value-cell">
              <el-image
                  v-if="item.type === 'img'"
                  :src="item.displayValue"
                  :preview-src-list="[item.displayValue]"
                  class="field-img"
                  fit="contain"
              />
              <span v-else class="value-text">{{ item.displayValue }}</span>
            </td>
          </tr>
          <tr v-if="!tableRows.length">
            <td colspan="2" class="empty-cell">暂无下单内容</td>
          </tr>
        </tbody>
      </table>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="success" :loading="saving" @click="saveAsImage">保存为图片</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Message } from 'element-ui'
import { buildNewsMessageImageName, buildNewsMessageTableRows } from '@/utils/newsMessageContentUtil'
import { saveElementAsImage } from '@/utils/saveElementAsImage'

export default {
  name: 'NewsMessageContentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: null,
    },
    fileBaseUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      saving: false,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    tableRows() {
      return buildNewsMessageTableRows(this.row, this.fileBaseUrl)
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    async saveAsImage() {
      if (!this.$refs.captureArea) {
        return
      }
      this.saving = true
      try {
        await this.$nextTick()
        await this.waitForImages(this.$refs.captureArea)
        const filename = buildNewsMessageImageName(this.row)
        await saveElementAsImage(this.$refs.captureArea, filename)
        Message({
          message: '图片已保存',
          type: 'success',
          duration: 3000,
        })
      } catch (e) {
        Message({
          message: '保存图片失败，请稍后重试',
          type: 'error',
          duration: 3000,
        })
      } finally {
        this.saving = false
      }
    },
    waitForImages(element) {
      const images = element.querySelectorAll('img')
      const tasks = Array.from(images).map(img => {
        if (img.complete) {
          return Promise.resolve()
        }
        return new Promise(resolve => {
          img.onload = resolve
          img.onerror = resolve
        })
      })
      return Promise.all(tasks)
    },
  },
}
</script>

<style lang="scss" scoped>
.message-content-capture {
  background: #fff;
  padding: 8px;
}

.capture-header {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}

.message-content-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 14px;
  color: #303133;

  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 10px 12px;
    vertical-align: top;
    word-break: break-all;
  }

  th {
    background: #f5f7fa;
    font-weight: 600;
    text-align: center;
  }

  .label-cell {
    width: 32%;
    background: #fafafa;
    font-weight: 500;
  }

  .value-cell {
    width: 68%;
  }

  .value-text {
    white-space: pre-wrap;
    line-height: 1.6;
  }

  .field-img {
    max-width: 180px;
    max-height: 180px;
    display: block;
    border-radius: 4px;
  }

  .empty-cell {
    text-align: center;
    color: #909399;
  }
}
</style>
